<script lang="ts">
	import type { IconName } from '$lib/components/icons/types.ts';
	import Badge from '$lib/components/atoms/badge/Badge.svelte';
	import Icon from '$lib/components/icons/Icon.svelte';
	import CarButton from '$lib/components/itinerary/options/cars/CarButton.svelte';

	interface Props {
		icon?: IconName;
		text: string;
		badgeText?: string;
		isTransparent?: boolean;
		disabled?: boolean;
		onclick?: () => void;
	}

	const {
		icon,
		text,
		badgeText,
		isTransparent = false,
		disabled = false,
		onclick,
	}: Props = $props();
</script>

<CarButton {isTransparent} {disabled} {onclick}>
	<div class="flex flex-col items-center justify-center gap-2 text-center">
		{#if icon}
			<Icon {icon} class="text-2xl" />
		{:else if badgeText}
			<Badge size="sm" text={badgeText} color="carAction" isSquare />
		{/if}
		<span class="text-md">{text}</span>
	</div>
</CarButton>
